/**
 * @fileoverview FiledStrip: "Filed by Grow", the strip above the piles on the Photos page (B160). It lists the photos Grow was sure
 * of and filed onto their plants by itself in the last photos.FILED_SHOW_HOURS, newest first, each one FiledByGrowLine (the photo,
 * the server's sentence "Filed to Sweet Horizon peas (Front bed)", and Move). Move opens the one move sheet (askMovePhoto), which
 * moves the photo to the right plant. The server sends the list and the window (GET /tray `filed`); nothing is drawn when it is
 * empty or absent.
 *
 * Where: PhotoTray (/plants/photos).
 * API: none; the list is GET /tray's, and the move is MovePhotoSheet's (PUT /photos/:plantObjId/:photoId/plant).
 * Words (en/es): tray.filed.heading, tray.filed.move (FiledByGrowLine).
 *
 * @module FiledStrip
 */

import React from 'react';
import { FiledByGrowLine } from '@/shared/components/ui/FiledByGrowLine';
import { useTranslation } from '@/shared/hooks/useTranslation';
import { askMovePhoto } from '@/shared/lib/movePhoto';
import type { FiledPhoto } from '@/shared/api/tray';

/** What the strip is given. */
interface FiledStripProps {
  /** The photos Grow filed lately, newest first, as GET /tray sent them; none or absent draws nothing. */
  filed?: FiledPhoto[];
}

/**
 * The strip of photos Grow filed by itself.
 *
 * @param props - FiledStripProps.
 */
export const FiledStrip: React.FC<FiledStripProps> = ({ filed }) => {
  const { reactTranslate: t } = useTranslation();
  if (!filed || filed.length === 0) return null;
  return (
    <section aria-label={t('tray.filed.heading')} className="mb-4">
      <h2 className="mb-1 text-sm font-semibold">{t('tray.filed.heading')}</h2>
      <ul className="divide-y divide-border">
        {filed.map((each) => (
          <li key={each.trayId}>
            <FiledByGrowLine
              text={each.line}
              thumbUrl={each.thumbUrl}
              onMove={() => askMovePhoto({ plantObjId: each.plantObjId, photoIds: each.photoIds })}
            />
          </li>
        ))}
      </ul>
    </section>
  );
};
